import {GET_ENTITY_ADMIN_KEY_CONTACTS, GET_ENTITY_ADMINS_DETAILS, CLEAR_ALL_PROJECTS} from '../actions/actiontypes';
import initialstate from './initialstate';

export default function entityAdminsKeyContactsReducer(state = initialstate.entityAdminsKeyContacts, action) {
	switch (action.type) {
		case GET_ENTITY_ADMIN_KEY_CONTACTS:
			if (action.response) {
				return {...state, [action.projectId]: action.response} || state;
			}
			return state;
		case GET_ENTITY_ADMINS_DETAILS:
			if (action.response) {
				var orgStructure = action.orgStructure.map(entity => { 
					let contacts = [];
					entity.entityAdminsIds?.forEach((adminId) => { 
						let user = action.response.find(x => x.userId == adminId);
						if(user)
						{
							contacts.push({
								userId: adminId,
								firstName: user?.firstName,
								lastName: user?.lastName,
								emailAddress: user?.emailAddress
							});
						}
					});

					return {
						entityId: entity.entityId,
						entityName: entity.entityName,
						contacts: contacts
					}
				})}
				return {...state, [action.projectId]: orgStructure} || state;
		case CLEAR_ALL_PROJECTS:
			return initialstate.entityAdminsKeyContacts;
		default:
			return state;
	}
}